var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSamples(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11829",
    "data-name": "Group 11829",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.384,
    height: 15.044,
    viewBox: "0 0 14.384 15.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16863",
    "data-name": "Rectangle 16863",
    width: 14.384,
    height: 15.044,
    fill: "#ee7d11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11828",
    "data-name": "Group 11828",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37756",
    "data-name": "Path 37756",
    d: "M8.71,1.809l-.7-.657L9.072,0l5.312,4.895L13.325,6.047l-.653-.587L10.7,7.6q-2.821,3.056-5.648,6.108a5.744,5.744,0,0,1-.938.814,2.344,2.344,0,0,1-3.253-.287A2.432,2.432,0,0,1,.6,10.762,22.845,22.845,0,0,1,2.359,8.713Q5.413,5.375,8.487,2.057c.069-.074.135-.151.223-.248m.531.483a1.5,1.5,0,0,1-.12.182q-3.644,3.959-7.286,7.92a6.161,6.161,0,0,0-.754,1.015,1.667,1.667,0,0,0,.431,2.39c.084.07.169.14.26.2a1.386,1.386,0,0,0,1.613.078,6.239,6.239,0,0,0,1.2-.97c2.3-2.468,4.585-4.956,6.874-7.438l.665-.724L9.241,2.292",
    transform: "translate(0)",
    fill: "#ee7d11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37757",
    "data-name": "Path 37757",
    d: "M34.492,121.563l2.086,1.92c-.053.065-.093.121-.139.17q-2.3,2.5-4.6,4.987a4.61,4.61,0,0,1-.792.692,1.182,1.182,0,0,1-1.549-.151,1.22,1.22,0,0,1-.41-1.527,3.181,3.181,0,0,1,.522-.8c1.58-1.736,3.174-3.46,4.764-5.188a1.5,1.5,0,0,1,.12-.1",
    transform: "translate(-27.603 -115.85)",
    fill: "#ee7d11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamples);
export default __webpack_public_path__ + "static/media/Samples.c8aea251f0a14b49cb5f420e01ff0c9c.svg";
export { ForwardRef as ReactComponent };